import { render, staticRenderFns } from "./expire.vue?vue&type=template&id=6e030530&scoped=true&"
import script from "./expire.vue?vue&type=script&lang=js&"
export * from "./expire.vue?vue&type=script&lang=js&"
import style0 from "./expire.vue?vue&type=style&index=0&id=6e030530&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e030530",
  null
  
)

export default component.exports